export default [
  {
    ru: {
      title: "ТЕПЛОВАЯ ЭНЕРГЕТИКА",
      content: "<p class='py-2'>Наша компания на протяжении более 20 лет выполняет работы по ремонту электродвигателей для тепловых станций Украины и других стран. Специалисты Электропромремонт регулярно выполняют работы как на территории заказчика (при ремонте крупногабаритного оборудования), так и на нашей производственной базе. Мы хорошо знаем ваше оборудование и с легкостью выполним ремонт:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Мельничных элеткродвигателей типа СДСЗ 2000/100, СДМ-20-49-60, 2000 кВт, 100 об/мин (В том числе их демонтаж и монтаж)</li>\n" +
        "<li class='list-disc'>Электродвигателей Дымососов и Дутьевых вентиляторов типа ДАЗО 19-10-12, ДАЗО 19-10-12/10, ДАЗО 2-18-8-10/12 и прочих.</li>\n" +
        "<li class='list-disc'>Электродвигателей Питательных электронасосов типа 4АЗМ-5000/6000, АЗМ-8000, АС-5000, АТД-3500.</li>\n" +
        "<li class='list-disc'>Электродвигателей Мельничных вентиляторов типа ДАЗО2-12-42-8 и другие.</li>" +
        "<li class='list-disc'>Электродвигателей Циркуляционных насосов типа ВДН, АВ и прочее.</li>" +
        "</ul>\n",
      image: "thermal_energy.jpeg",
      count: [
        {
          start: 100,
          end: 4000,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 3000,
          step: 50,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 2400,
          step: 50,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "THERMAL ENERGY",
      content: "<p class='py-2'>For over 20 years, our company has been carrying out repairs of electric motors for thermal stations in Ukraine and other countries. Specialists of Elektropromremont regularly perform work both on the territory of the customer (when repairing large-sized equipment), and on our production base. We know your equipment well and can easily carry out repairs:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Mill electric motors of type SDSZ 2000/100, SDM-20-49-60, 2000 kW, 100 rpm (including their dismantling and installation);</li>\n" +
        "<li class='list-disc'>Electric motors of smoke exhausters and blowers of the type DAZO 19-10-12, DAZO 19-10-12 / 10, DAZO 2-18-8-10-10 / 12 and others;</li>\n" +
        "<li class='list-disc'>Electric motors of nutritious electric pumps of type 4AZM-5000/6000, AZM-8000, AC-5000, ATD-3500;</li>\n" +
        "<li class='list-disc'>Electric motors of mill fans of the DAZO2-12-42-8 type and others;</li>" +
        "<li class='list-disc'>Electric motors of circulation pumps such as VDN, AB and others</li>" +
        "</ul>\n",
      image: "thermal_energy.jpeg",
      count: [
        {
          start: 100,
          end: 4000,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 3000,
          step: 50,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 2400,
          step: 50,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "ТЕПЛОВА ЕНЕРГЕТИКА",
      content: "<p class='py-2'>Наша компанія протягом більше 20 років виконує роботи по ремонту електродвигунів для теплових станцій України та інших країн. Фахівці Електропромремонт регулярно виконують роботи як на території замовника (при ремонті великогабаритного обладнання), так і на нашій виробничій базі. Ми добре знаємо ваше обладнання і з легкістю виконаємо ремонт:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Млинові елеткродвигунів типу СДСЗ 2000/100, СДМ-20-49-60, потужність 2000 кВт, 100 об / хв (В тому числі їх демонтаж та монтаж);</li>\n" +
        "<li class='list-disc'>Електродвигунів Димососів і Дутьївих вентиляторів типу ДАЗО 19-10-12, ДАЗО 19-10-12 / 10, ДАЗО 2-18-8-10 / 12 та інших;</li>\n" +
        "<li class='list-disc'>Електродвигунів живильних електронасосів типу 4АЗМ-5000/6000, АЗМ-8000, АС-5000, АТД-3500.</li>\n" +
        "<li class='list-disc'>Електродвигунів млинових вентиляторів типу ДАЗО2-12-42-8 та інші;</li>" +
        "<li class='list-disc'>Електродвигунів циркуляційних насосів типу ВДН, АВ та інше.</li>" +
        "</ul>\n",
      image: "thermal_energy.jpeg",
      count: [
        {
          start: 100,
          end: 4000,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 3000,
          step: 50,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 2400,
          step: 50,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "Гидроэнергетика",
      content: "<p class='py-2'>Одной из самых больших проблем гидроэнергетики – это старые гидрогенераторы, которые вводились в эксплуатацию в 30 – 50х годах предыдущего столетия. Кроме этого, большие габаритные размеры гидрогенераторов и труднодоступность ГЭС не позволяют с легкостью выполнить замену или заводской ремонт электрооборудования. В связи с этим нами организованны специальные выездные бригады, которые обучены и имеют возможность выполнения капитального ремонта гидрогенераторов любой сложности и конструкции обмотки, проведение капитального ремонта явно выраженных полюсов ротора, проведения всех необходимых в ходе ремонта пооперационных испытаний.</p>\n",
      image: "hydro_energy.jpeg",
      count: [
        {
          start: 1,
          end: 100,
          step: 2,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 1000,
          step: 10,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 500,
          step: 5,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "Hydro energy",
      content: "<p class='py-2'>One of the biggest problems of hydro energy is the old hydrogenerators, which were commissioned in the 30-50s years of the previous century. Other than that, the large overall dimensions of hydrogenerators and the inaccessibility of hydroelectric power stations do not allow for easy replacement or factory repair of electrical equipment. In this regard, we organized special field teams that are trained and have the ability to perform major repairs of hydrogenerators of any complexity and winding design, carry out major repairs of pronounced rotor poles, and carry out all operational tests required during the repair.</p>\n",
      image: "hydro_energy.jpeg",
      count: [
        {
          start: 1,
          end: 100,
          step: 2,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 1000,
          step: 10,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 500,
          step: 5,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "Гідроенергетика",
      content: "<p class='py-2'>Однією з найбільших проблем гідроенергетики - це старі гідрогенератори, які вводилися в експлуатацію в 30 - 50-х роках попереднього століття. Крім цього, великі габаритні розміри гідрогенераторів і важкодоступність ГЕС не дозволяють з легкістю виконати заміну або заводський ремонт електрообладнання. У зв'язку з цим нами організовані спеціальні виїзні бригади, які навчені і мають можливість виконання капітального ремонту гідрогенераторів будь-якої складності та конструкції обмотки, проведення капітального ремонту явно виражених полюсів ротора, проведення всіх необхідних в ході ремонту післяопераційних випробувань.</p>\n",
      image: "hydro_energy.jpeg",
      count: [
        {
          start: 1,
          end: 100,
          step: 2,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 1000,
          step: 10,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 500,
          step: 5,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "АТОМНАЯ ЭНЕРГЕТИКА",
      content: "<p class='py-2'>Основным принципом работы с Атомными электростанциями является четкое соответствие требованиям Заказчика. Так на протяжении многих лет мы регулярно проходим аттестацию НАЭК Энергоатом и являемся сертифицированным поставщиком запасных частей к электрическим двигателям. Нами регулярно выполняются поставки следующих комплектующих:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Секции обмотки статора к электродвигателю типа ДВДА 216/64-16-20КУХЛ4, ДВДА - 260/99-20-24УЗ;</li>\n" +
        "<li class='list-disc'>Стержни верхней и нижней обмотки статора типа ВАЗ 215/109-6АМ05 8000 кВт</li>\n" +
        "<li class='list-disc'>Секции обмотки статора к электродвигателю типа АВ-15-36-8АМУ4, АВ-113-4М и др.</li>\n" +
        "</ul>\n",
      image: "nuclear_energy.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 800,
          step: 15,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "NUCLEAR ENERGY",
      content: "<p class='py-2'>The main principle of work with nuclear power plants is a clear compliance with the requirements of the customer. We regularly undergo certification by NAEC Energoatom for many years and are a certified supplier of spare parts for electric motors. We regularly deliver the following components:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Section of the stator winding to the motor type DVDA 216 / 64-16-20KUHL4, DVDA - 260 / 99-20-24UZ;</li>\n" +
        "<li class='list-disc'>Rods of the upper and lower windings of the stator type VAZ 215 / 109-6AM05 8000 kW;</li>\n" +
        "<li class='list-disc'>Section of the stator winding to the motor type AB-15-36-8AMU4, AV-113-4M, etc.</li>\n" +
        "</ul>\n",
      image: "nuclear_energy.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 800,
          step: 15,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "АТОМНА ЕНЕРГЕТИКА",
      content: "<p class='py-2'>Основним принципом роботи з Атомними електростанціями є чітка відповідність вимогам Замовника. Так протягом багатьох років ми регулярно проходимо атестацію НАЕК Енергоатом, а також є сертифікованим постачальником запасних частин для електричних двигунів. Нами регулярно виконуються поставки наступних комплектуючих:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Секції обмотки статора до електродвигуна типу ДВДА 216/64-16-20КУХЛ4, ДВДА - 260/99-20-24УЗ;</li>\n" +
        "<li class='list-disc'>Стрижні верхньої і нижньої обмотки статора типу ВАЗ 215/109-6АМ05 8000 кВт;</li>\n" +
        "<li class='list-disc'>Секції обмотки статора до електродвигуна типу АВ-15-36-8АМУ4, АВ-113-4М та ін.</li>\n" +
        "</ul>\n",
      image: "nuclear_energy.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 800,
          step: 15,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "ЦЕМЕНТНЫЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>Для цементных предприятий бесперебойная работа электродвигателей – является одним из ключевых приоритетов в организации производства. Для этого им необходимо привлечение подрядных организаций, таких как Электропромремонт. Наша компания хорошо знает специфику работы цементных предприятий и на постоянной основе выполняет ремонты следующих электродвигателей:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Синхронные электродвигатели главного привода цементных мельниц типа СДМ-20-49-60 2000 кВт, ДС-213/29-24 630 кВт</li>\n" +
        "<li class='list-disc'>Генераторы постоянного тока типа 2ГПЭ- 85/36-6, 1250 кВт, 1000 кВт и прочие;</li>\n" +
        "<li class='list-disc'>Электродвигатели постоянного тока типа МПЭ, ДПЭ, ДПВ, ДЭ, ГП и другие мощностью от 54кВт до 1000кВт;</li>\n" +
        "<li class='list-disc'>Синхронные электродвигатели типа СДЭ- 1250, 1000, 800, 630 кВт.</li>" +
        "<li class='list-disc'>Асинхронные электродвигатели с короткозамкнутым и фазным ротором, такие как А0-113, АКЗ и другие.</li>" +
        "<li class='list-disc'>А так же электродвигатели производства ABB, Siemens и прочие электродвигатели.</li>" +
        "</ul>\n",
      image: "cement_enterpris.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 350,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "Cement enterprises",
      content: "<p class='py-2'>For cement companies, uninterrupted operation of electric motors is one of the key priorities in the organization of production. For this purpose they need to involve contractors, such as Elektropromremont. Our company is well aware of the specifics of cement plants and carries out repairs of the following electric motors on a continuous basis:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Cement mills main drive synchronous electric motors type SDM-20-49-60 2000 kW, DS-213/29-24 630 kW</li>\n" +
        "<li class='list-disc'>DC generators type 2GPE-85/36-6, 1250 kW, 1000 kW and others;</li>\n" +
        "<li class='list-disc'>DC electric motors MPE, DPE, DPV, DE, GP and others with capacities from 54kW to 1000kW;</li>\n" +
        "<li class='list-disc'>Synchronous electric motors of type SDE-1250, 1000, 800, 630 kW.</li>" +
        "<li class='list-disc'>Asynchronous electric motors with squirrel-cage and phase-wound rotor, such as A0-113, AKZ and others.</li>" +
        "<li class='list-disc'>As well as electric motors made by ABB, Siemens and other electric motors.</li>" +
        "</ul>\n",
      image: "cement_enterpris.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 350,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "Цементні підприємства",
      content: "<p class='py-2'>Наша компанія протягом понад 20 років виконує роботи з ремонту електродвигунів для теплових станцій України та інших країн. Фахівці Електропромремонт регулярно виконують роботи як на території замовника (під час ремонту великогабаритного обладнання), так і на нашій виробничій базі. Ми добре знаємо ваше обладнання і з легкістю виконаємо ремонт:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Синхронні електродвигуни головного приводу цементних млинів типу СДМ-20-49-60 2000 кВт, ДС-213/29-24 630 кВт</li>\n" +
        "<li class='list-disc'>Генератори постійного струму типу 2ГПЭ- 85/36-6, 1250 кВт, 1000 кВт та інші</li>\n" +
        "<li class='list-disc'>Електродвигуни постійного струму типу МПЕ, ДПЕ, ДПВ, ДЕ, ГП та інші потужністю від 54кВт до 1000кВт</li>\n" +
        "<li class='list-disc'>Синхронні електродвигуни типу СДЕ- 1250, 1000, 800, 630 кВт</li>" +
        "<li class='list-disc'>Асинхронні електродвигуни з короткозамкненим і фазним ротором, такі як А0-113, АКЗ та інші</li>" +
        "<li class='list-disc'>А також електродвигуни виробництва ABB, Siemens та інші електродвигуни</li>" +
        "</ul>\n",
      image: "cement_enterpris.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 350,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "ХИМИЧЕСКИЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>На предприятиях Химической промышленности установлено большое количество крупных электрических двигателей как отечественного, так и импортного производства. Специалисты нашего предприятия часто сталкивались со сложными ремонтами, как в нашем электроремонтном цеху, так и при выполнении ремонта крупногабаритных электродвигателей по месту установки:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Синхронные электродвигатели компрессорных установок типа IEB-155-75-4 ( 4800 кВт, 1500 об/мин), 1ЕВ-229-44-20Z (1500 кВт, 300 об/мин), RPC-133-77-4, Р-4800кВт, SAT-23.7.55.18, P-6780кВт;</li>\n" +
        "<li class='list-disc'>Синхронные электродвигатели типа СДН-15-49-6, СДК2-19-39-16, 2000кВт, 375об./мин.;</li>\n" +
        "<li class='list-disc'>Синхронные турбо электродвигатели типа СТД-3150, СТМ-1500-2, RNC-99.5-52.5-4, Р-1650кВт;</li>\n" +
        "<li class='list-disc'>Асинхронные электродвигатели типа 2ФАЗ-800/6000, А-13-62-8, А-113-4М и другие.</li>" +
        "</ul>\n",
      image: "chemical_enterprises.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 350,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "CHEMICAL ENTERPRISES",
      content: "<p class='py-2'>A large number of large electric motors of both domestic and foreign production were installed at the enterprises of the chemical Industry. Specialists of our company often faced with complex repairs, both in our electrical repair shop, and when performing repairs of large-sized electric motors at the installation site:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Synchronous electric motors of compressor units like IEB-155-75-4 (4800 kW, 1500 rpm), 1ЕВ-229-44-20Z (1500 kW, 300 rpm), RPC-133-77-4, Р-4800 kW , SAT-23.7.55.18, P-6780kW;</li>\n" +
        "<li class='list-disc'>Synchronous electric motors of type SDN-15-49-6, SDK2-19-39-16, 2000 kW, 375 rpm;</li>\n" +
        "<li class='list-disc'>Synchronous turbo electric motors of the type STD-3150, STM-1500-2, RNC-99.5-52.5-4, R-1650kW;</li>\n" +
        "<li class='list-disc'>Asynchronous electric motors of type 2FAZ-800/6000, A-13-62-8, A-113-4M and others..</li>" +
        "</ul>\n",
      image: "chemical_enterprises.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 350,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "ХІМІЧНІ ПІДПРИЄМСТВА",
      content: "<p class='py-2'>На підприємствах хімічної промисловості встановлена велика кількість потужних електричних двигунів як вітчизняного, так і імпортного виробництва. Фахівці нашого підприємства часто зіштовхувалися зі складними ремонтами, як в нашому Електроремонтному цеху, так і при виконанні ремонту великогабаритних електродвигунів за місцем установки:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Синхронні електродвигуни компресорних установок типу IEB-155-75-4 (4800 кВт, 1500 об/хв), 1ЕВ-229-44-20Z (1500 кВт, 300 об/хв), RPC-133-77-4, Р-4800кВт, SAT-23.7.55.18, P-6780кВт;</li>\n" +
        "<li class='list-disc'>Синхронні електродвигуни компресорних установок типу IEB-155-75-4 (4800 кВт, 1500 об/хв), 1ЕВ-229-44-20Z (1500 кВт, 300 об/хв), RPC-133-77-4, Р-4800кВт, SAT-23.7.55.18, P-6780кВт;</li>\n" +
        "<li class='list-disc'>Синхронні турбо електродвигуни типу СТД-3150, СТМ-1500-2, RNC-99.5-52.5-4, Р-1650кВт;</li>\n" +
        "<li class='list-disc'>Асинхронні електродвигуни типу 2ФАЗ-800/6000, А-13-62-8, А-113-4М та інші.</li>" +
        "</ul>\n",
      image: "chemical_enterprises.jpeg",
      count: [
        {
          start: 10,
          end: 500,
          step: 10,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 10,
          end: 400,
          step: 8,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 10,
          end: 350,
          step: 8,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "ГАЗОДОБЫВАЮЩИЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>С каждым годом в Украине увеличиваются объемы добычи природного газа. Выполняя капитальные ремонты электродвигателей, мы обеспечиваем бесперебойную работу оборудования и механизмов для добычи и транспортировки «голубого топлива».</p>\n" +
        "\n" +
        "<p class='py-2'>Газоперекачивающие станции оборудованы высоковольтными компрессорными электродвигателями серии СТД, СТМ и др. Наш опыт позволяет выполнить ремонтные работы как статоров с жесткими секциями, так и роторов с концентрическими обмотками.</p>\n",
      image: "gas_producing_enterprises.jpeg",
      count: [
        {
          start: 1,
          end: 200,
          step: 4,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 150,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 90,
          step: 2,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "GAS PRODUCING ENTERPRISES",
      content: "<p class='py-2'>Every year the volume of natural gas production increases in Ukraine. Performing major repairs of electric motors, we provide uninterrupted operation of equipment and mechanisms for the production and transportation of \"blue fuel\".</p>\n" +
        "\n" +
        "<p class='py-2'>Gas pumping stations are equipped with high-voltage compressor motors STD, STM, etc. Our experience allows us to perform repair work as stators with rigid sections and rotors with concentric windings.</p>\n",
      image: "gas_producing_enterprises.jpeg",
      count: [
        {
          start: 1,
          end: 200,
          step: 4,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 150,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 90,
          step: 2,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "ГАЗОДОБУВНІ ПІДПРИЄМСТВА",
      content: "<p class='py-2'>З кожним роком в Україні збільшуються обсяги видобутку природного газу. Виконуючи капітальні ремонти електродвигунів, ми забезпечуємо безперебійну роботу обладнання та механізмів для видобутку і транспортування «блакитного палива».</p>\n" +
        "\n" +
        "<p class='py-2'>Газоперекачувальні станції обладнані високовольтними компресорними електродвигунами серії СТД, СТМ та ін. Наш досвід дозволяє виконати ремонтні роботи як статорів з жорсткими секціями, так і роторів з концентричними обмотками.</p>\n",
      image: "gas_producing_enterprises.jpeg",
      count: [
        {
          start: 1,
          end: 200,
          step: 4,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 150,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 90,
          step: 2,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "МЕТАЛЛУРГИЧЕСКИЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>Металлургические комбинаты насыщены электрическими машинами как постоянного, так и переменного тока, которые работают в крайне-тяжелых условиях (запылённость, повышенная температура и её резкие перепады).</p>\n" +
        "\n" +
        "<p class='py-2'>Ориентируясь на электродвигатели большой мощности, Мы обеспечиваем качественным ремонтом доменное производство, конвертерное производство, кислородные цеха, прокатные станы и другие структурные подразделения крупнейших металлургических предприятий нашей страны и ближнего зарубежья качественными ремонтами и техническим обслуживанием. Имеет огромный опыт выполнения ремонта отечественных и импортных электродвигателей:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Электрические машины постоянного тока типа Д, МП, МПЭ, MD, GMG, GKG, П2 мощностью от 50кВт до 12МВт;</li>\n" +
        "<li class='list-disc'>Высоковольтные асинхронные электродвигатели (в том числе и многоскоростные) типа А4, А, ДАЗО, ДАЗ, АЗМ, АОД и другие, мощностью от 320кВт до 5000кВт;</li>\n" +
        "<li class='list-disc'>Синхронные электродвигатели типа СТД, МС, СД и другие, мощностью от 320кВт до 12.5МВт;</li>\n" +
        "<li class='list-disc'>Грузоподъемные электромагниты.</li>" +
        "</ul>\n",
      image: "metallurgical_enterprises.jpeg",
      count: [
        {
          start: 100,
          end: 4000,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 3200,
          step: 50,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 2500,
          step: 50,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "METALLURGICAL ENTERPRISES",
      content: "<p class='py-2'>Мetallurgical plants are saturated with electric machines of both direct and alternating current, which operate in extremely difficult conditions (dustiness, high temperature and its sudden changes).</p>\n" +
        "\n" +
        "<p class='py-2'>Focusing on electric motors of high power, we provide high-quality repairs to blast furnace production, converter production, oxygen shops, rolling mills and other structural divisions of the largest metallurgical enterprises of our country and neighboring countries with high-quality repairs and maintenance. It has vast experience in repairing domestic and imported electric motors:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Electric DC machines of type D, MP, MPE, MD, GMG, GKG, P2 with a capacity of 50 kW to 12 MW;</li>\n" +
        "<li class='list-disc'>High-voltage asynchronous electric motors (including multi-speed) of type A4, A, AEPB, DAZ, AZM, AOD and others, with power from 320kW to 5000kW;</li>\n" +
        "<li class='list-disc'>Synchronous electric motors of the type STD, MS, SD and others, with a capacity of 320 kW to 12.5 MW;</li>\n" +
        "<li class='list-disc'>Lifting electromagnets.</li>" +
        "</ul>\n",
      image: "metallurgical_enterprises.jpeg",
      count: [
        {
          start: 100,
          end: 4000,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 3200,
          step: 50,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 2500,
          step: 50,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "МЕТАЛУРГІЙНІ ПІДПРИЄМСТВА",
      content: "<p class='py-2'>Металургійні комбінати насичені електричними машинами як постійного, так і змінного струму, які працюють в крайньо-важких умовах (запиленість, підвищена температура та її різкі перепади).</p>\n" +
        "\n" +
        "<p class='py-2'>Орієнтуючись на електродвигуни великої потужності, Ми забезпечуємо якісним ремонтом доменне виробництво, конвертерне виробництво, кисневі цеха, прокатні стани й інші структурні підрозділи найбільших металургійних підприємств нашої країни і ближнього зарубіжжя якісними ремонтами і технічним обслуговуванням. Має величезний досвід виконання ремонту вітчизняних та імпортних електродвигунів:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Електричні машини постійного струму типу Д, МП, МПЕ, MD, GMG, GKG, П2 потужністю від 50кВт до 12МВт;</li>\n" +
        "<li class='list-disc'>Високовольтні асинхронні електродвигуни (в тому числі і багатошвидкісні) типу А4, А, ДАЗО, ДАЗ, АЗМ, АОД та інші, потужністю від 320кВт до 5000кВт;</li>\n" +
        "<li class='list-disc'>Синхронні електродвигуни типу СТД, МС, СД та інші, потужністю від 320кВт до 12.5МВт;</li>\n" +
        "<li class='list-disc'>Вантажопідйомні електромагніти.</li>" +
        "</ul>\n",
      image: "metallurgical_enterprises.jpeg",
      count: [
        {
          start: 100,
          end: 4000,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 3200,
          step: 50,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 2500,
          step: 50,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "УГОЛЬНЫЕ КОМПАНИИ",
      content: "<p class='py-2'>Важность бесперебойной работы электрических двигателей, находящихся в угольных шахтах – это в первую очередь безопасность для ее работников. Для возможности осуществления ремонтов электродвигателей находящихся во взрывоопасных зонах угольных предприятий, наша компания на постоянной основе проходит специальные проверки в государственных органах и получает соответствующие разрешения. Мы понимаем особенности ремонта взрывозащищенных электродвигателей и с легкостью выполним ремонт:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Электродвигателей типа ВАО2-560 – 1600 кВт, 1250 кВт, 800 кВт, 630 кВт, 500 кВт, 400 кВт и прочие.</li>\n" +
        "<li class='list-disc'>Электродвигателей подъемных установок типа АКН, АКЗ</li>\n" +
        "<li class='list-disc'>Электродвигателей с фазным ротором типа ВАОК, МА и ВРК – 110 кВт, 90 кВт, 75 кВт и прочие.</li>\n" +
        "<li class='list-disc'> Электродвигателей типа ЭДКОФ, ЭДКРВ – 160 кВт, 110 кВт, 90 кВт, 75 кВт, 55кВт и прочие.</li>" +
        "<li class='list-disc'>Электродвигателей типа ДРТ.</li>" +
        "</ul>\n",
      image: "coal_companies.jpeg",
      count: [
        {
          start: 100,
          end: 3500,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 2000,
          step: 100,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 1200,
          step: 25,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "COAL COMPANIES",
      content: "<p class='py-2'>The importance of the smooth operation of electric motors in coal mines is, first and foremost, safety for its employees. Our company constantly passes special inspections in government bodies and receives appropriate permits for the possibility of repairing electric motors located in hazardous areas of coal enterprises. We understand the features of repair of explosion-proof electric motors and easily carry out repairs:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Electric motors of VAO2-560 type - 1600 kW, 1250 kW, 800 kW, 630 kW, 500 kW, 400 kW and others.</li>\n" +
        "<li class='list-disc'>Electric motors of lifting units, type AKN, AKZ</li>\n" +
        "<li class='list-disc'>Electric motors with a phase rotor of the type VAOK, MA and VRK - 110 kW, 90 kW, 75 kW and others.</li>\n" +
        "<li class='list-disc'>Electric motors of the type EDKOF, EDKRV - 160 kW, 110 kW, 90 kW, 75 kW, 55 kW and others.</li>" +
        "<li class='list-disc'>Electric motors of DRT type.</li>" +
        "</ul>\n",
      image: "coal_companies.jpeg",
      count: [
        {
          start: 100,
          end: 3500,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 2000,
          step: 100,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 1200,
          step: 25,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "ВУГІЛЬНІ КОМПАНІЇ",
      content: "<p class='py-2'>Важливість безперебійної роботи електричних двигунів, які перебувають у вугільних шахтах - це в першу чергу безпеку для її працівників. Для можливості здійснення ремонтів електродвигунів, які розміщені у вибухонебезпечних зонах вугільних підприємств, наша компанія на постійній основі проходить спеціальні перевірки в державних органах і отримує відповідні дозволи. Ми розуміємо особливості ремонту вибухозахищених електродвигунів і з легкістю виконаємо ремонт:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Електродвигунів типу ВАО2-560 - 1600 кВт, 1250 кВт, 800 кВт, 630 кВт, 500 кВт, 400 кВт і інші.</li>\n" +
        "<li class='list-disc'>Електродвигунів підйомних установок типу АКН, АКЗ</li>\n" +
        "<li class='list-disc'>Електродвигунів з фазним ротором типу ВАОК, МА і ВРК - 110 кВт, 90 кВт, 75 кВт та інші.</li>\n" +
        "<li class='list-disc'>Електродвигунів типу ЕДКОФ, ЕДКРВ - 160 кВт, 110 кВт, 90 кВт, 75 кВт, 55кВт та інші.</li>" +
        "<li class='list-disc'>Електродвигунів типу ДРТ.</li>" +
        "</ul>\n",
      image: "coal_companies.jpeg",
      count: [
        {
          start: 100,
          end: 3500,
          step: 50,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 2000,
          step: 100,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 100,
          end: 1200,
          step: 25,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "ГОРНООБОГАТИТЕЛЬНЫЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>Одними из первых наших заказчиков были Горно обогатительные предприятия, большое количество которых находится в нашем регионе. С того момента, нами выполнен ремонт большого количества электродвигателей экскаваторной группы, для дробильных фабрик, мельниц и обогатительных фабрик в том числе:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Генераторы постоянного тока типа ГПЭ-2500, ГПЭ-1250, и другие;</li>\n" +
        "<li class='list-disc'>Элеткродвигатели постоянного тока типа МПЭ, ДПЭ, ДПВ, ДЭ, ГП и другие мощностью от 54кВт до 1000кВт;</li>\n" +
        "<li class='list-disc'>Синхронные электродвигатели типа СДЭ 1600, 1250, 1000, 800, 630 кВт.</li>\n" +
        "<li class='list-disc'>Асинхронные электродвигатели с короткозамкнутым и фазным ротором, такие как АЭ-113, АКЗ и другие.</li>" +
        "</ul>\n",
      image: "mining.webp",
      count: [
        {
          start: 100,
          end: 1500,
          step: 25,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 1200,
          step: 20,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 50,
          end: 900,
          step: 35,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "MINING AND PROCESSING ENTERPRISES",
      content: "<p class='py-2'>One of our first customers was Mining and processing enterprises, a large number of which are located in our region. We have carried out the repair of a large number of electric motors of the excavator group from that moment, for crushing plants, mills and concentration plants, including:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Generators of direct current of type GPE-2500, GPE-1250, and others;</li>\n" +
        "<li class='list-disc'>Direct current electric motors of type MPE, DPE, DPV, DE, GP and others with a capacity of 54 kW to 1000 kW;</li>\n" +
        "<li class='list-disc'>Synchronous electric motors of type SDE 1600, 1250, 1000, 800, 630 kW.</li>\n" +
        "<li class='list-disc'>Asynchronous electric motors with squirrel-cage and phase rotors, such as AE-113, AKZ and others.</li>" +
        "</ul>\n",
      image: "mining.webp",
      count: [
        {
          start: 100,
          end: 1500,
          step: 25,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 1200,
          step: 20,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 50,
          end: 900,
          step: 35,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "ГІРНИЧО-ЗБАГАЧУВАЛЬНІ ПІДПРИЄМСТВА",
      content: "<p class='py-2'>Одними з перших наших замовників були Гірничо-збагачувальні підприємства, велика кількість яких знаходиться в нашому регіоні. З того моменту, нами виконано ремонт великої кількості електродвигунів екскаваторної групи, для дробильних фабрик, млинів і збагачувальних фабрик в тому числі:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Генератори постійного струму типу ДПЕ-2500, ГПЕ-1250, та інші;</li>\n" +
        "<li class='list-disc'>Елеткродвигуни постійного струму типу МПЕ, ДПЕ, ДПВ, ДЕ, ДП та інші потужністю від 54кВт до 1000кВт;</li>\n" +
        "<li class='list-disc'>Синхронні електродвигуни типу СДЕ 1600, 1250, 1000, 800, 630 кВт.</li>\n" +
        "<li class='list-disc'>Асинхронні електродвигуни з короткозамкненим та фазним ротором, такі як АЕ-113, АКЗ та інші.</li>" +
        "</ul>\n",
      image: "mining.webp",
      count: [
        {
          start: 100,
          end: 1500,
          step: 25,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 100,
          end: 1200,
          step: 20,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 50,
          end: 900,
          step: 35,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "ЖЕЛЕЗНАЯ ДОРОГА",
      content: "<p class='py-2'>Одним из основных критериев безопасных перевозок пассажиров и грузов – является регулярное обслуживание и ремонт подвижного состава. В ходе обслуживания локомотивного хозяйства немаловажной составляющей является ремонт тяговых электродвигателей. Наша компания осуществляет КР1, КР2 следующего тягового оборудования:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Тяговые электродвигатели для тепловозов, электровозов, трамваев, вагонов метро типа ЭД-118, ТЕ-006, ТЛ-2К, НД-406, ДК-117, НБ-514 и прочие;</li>\n" +
        "<li class='list-disc'>Тяговые генераторы для тепловозов, дизель поездов типа ГП-300, ГП-311, TD-802, TD-809, TD-812 ;</li>\n" +
        "<li class='list-disc'>А так же ремонт вспомогательных электрических машин.</li>\n" +
        "</ul>\n",
      image: "railway.jpeg",
      count: [
        {
          start: 10,
          end: 1100,
          step: 20,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 165,
          step: 5,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 200,
          step: 6,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "RAILWAY",
      content: "<p class='py-2'>One of the main criterias for the safe transport of passengers and goods is regular maintenance and repair of rolling stock. During maintenance of the locomotive economy, an important component is the repair of traction electric motors. Our company implements KP1, KP2 of the following traction equipment:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Traction motors for diesel locomotives, electric locomotives, trams, subway cars of type ED-118, TE-006, TL-2K, ND-406, DK-117, NB-514 and others;</li>\n" +
        "<li class='list-disc'>Traction generators for diesel locomotives, diesel trains of the type GP-300, GP-311, TD-802, TD-809, TD-812;</li>\n" +
        "<li class='list-disc'>As well as repair of auxiliary electrical machines.</li>\n" +
        "</ul>\n",
      image: "railway.jpeg",
      count: [
        {
          start: 10,
          end: 1100,
          step: 20,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 165,
          step: 5,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 200,
          step: 6,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "ЗАЛІЗНА ДОРОГА",
      content: "<p class='py-2'>Одним з основних критеріїв безпечних перевезень пасажирів і вантажів - є регулярне обслуговування та ремонт рухомого складу. В ході обслуговування локомотивного господарства важливою складовою є ремонт тягових електродвигунів. Наша компанія здійснює КР1, КР2 наступного тягового обладнання:</p>\n" +
        "\n" +
        "<ul class='px-8'>" +
        "<li class='list-disc'>Тягові електродвигуни для тепловозів, електровозів, трамваїв, вагонів метро типу ЕД-118, ТЕ-006, ТЛ-2К, НД-406, ДК-117, НБ-514 та інші;</li>\n" +
        "<li class='list-disc'>Тягові генератори для тепловозів, дизель-поїздів типу ГП-300, ДП-311, TD-802, TD-809, TD-812;</li>\n" +
        "<li class='list-disc'>А також ремонт допоміжних електричних машин.</li>\n" +
        "</ul>\n",
      image: "railway.jpeg",
      count: [
        {
          start: 10,
          end: 1100,
          step: 20,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 165,
          step: 5,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 200,
          step: 6,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "НЕФТЕПЕРЕРАБАТЫВАЮЩИЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>Нефтеперерабатывающие компании – это предприятия повышенной опасности с наивысшими требованиями по допуску подрядных организаций. Именно такой компанией является Электропромремонт, которая на постоянной основе проходит специальные проверки в государственных органах и получает соответствующие разрешения на ремонт электродвигателей во взрывоопасных зонах. Наши специалисты неоднократно проводили для НПЗ капитальные ремонты электродвигателей мощностью от 50 кВт до 8 МВт, как у нас на производственной базе, так и на территории Заказчика, на участках риформинга, полипропилена, каталитического крекинга и других участков.</p>\n",
      image: "oil_refineries.jpeg",
      count: [
        {
          start: 1,
          end: 500,
          step: 5,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 250,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 300,
          step: 3,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "OIL REFINING ENTERPRISES",
      content: "<p class='py-2'>Oil refining companies are high-risk enterprises with the highest requirements for the admission of contractors. Such a company is Elektropromremont, which constantly undergoes special checks in government bodies and receives appropriate permits for the repair of electric motors in hazardous areas. Our specialists have repeatedly carried out major repairs for the refinery of electric motors with a capacity from 50 kW to 8 MW, both at our production base and on the customer's territory, in the areas of reforming, polypropylene, catalytic cracking and other sites.</p>\n",
      image: "oil_refineries.jpeg",
      count: [
        {
          start: 1,
          end: 500,
          step: 5,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 250,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 300,
          step: 3,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "НАФТОПЕРЕРОБНІ ПІДПРИЄМСТВА",
      content: "<p class='py-2'>Нафтопереробні компанії - це підприємства підвищеної небезпеки з найвищими вимогами щодо допуску підрядних організацій. Саме такою компанією є Електропромремонт, яка на постійній основі проходить спеціальні перевірки в державних органах і отримує відповідні дозволи на ремонт електродвигунів у вибухонебезпечних зонах. Наші фахівці неодноразово проводили для НПЗ капітальні ремонти електродвигунів потужністю від 50 кВт до 8 МВт, як у нас на виробничій базі, так і на території Замовника, на ділянках риформінгу, поліпропілену, каталітичного крекінгу та інших ділянок.</p>\n",
      image: "oil_refineries.jpeg",
      count: [
        {
          start: 1,
          end: 500,
          step: 5,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 250,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 300,
          step: 3,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
  {
    ru: {
      title: "МАШИНОСТРОИТЕЛЬНЫЕ ПРЕДПРИЯТИЯ",
      content: "<p class='py-2'>Точность работ в машиностроении обеспечивается приводами постоянного тока, в том числе импортного производства. Наше предприятие имеет опыт выполнения работ по восстановлению работоспособности таких электродвигателей, так же изготовления и замены коллекторов. Кроме этого готовы произвести ремонт электродвигателей компрессорных установок либо поставить запасные части к синхронным и асинхронным электродвигателям (секции обмотки статора статора, вкладыши подшипников скольжения)</p>\n",
      image: "machine_building_enterprises.jpeg",
      count: [
        {
          start: 1,
          end: 300,
          step: 3,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 240,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 135,
          step: 1,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    en: {
      title: "MACHINE-BUILDING ENTERPRISES",
      content: "<p class='py-2'>The accuracy of work in mechanical motorering is provided by DC drives, including imported ones. Our enterprise has experience of performance of works on restoration of operability of such electric motors, as well as manufacture and replacement of collectors. In addition, we are ready to repair the electric motors of compressor units or supply spare parts for synchronous and asynchronous motors (stator winding sections, bearings inserts)</p>\n",
      image: "machine_building_enterprises.jpeg",
      count: [
        {
          start: 1,
          end: 300,
          step: 3,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 240,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 135,
          step: 1,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
    ua: {
      title: "МАШИНОБУДІВНІ ПІДПРИЄМСТВА",
      content: "<p class='py-2'>Точність робіт в машинобудуванні забезпечується приводами постійного струму, в тому числі імпортного виробництва. Наше підприємство має досвід виконання робіт по відновленню працездатності таких електродвигунів, так само виготовлення і заміни колекторів. Крім цього готові зробити ремонт електродвигунів компресорних установок або поставити запасні частини до синхронних і асинхронних електродвигунів (секції обмотки статора статора, вкладиші підшипників ковзання)</p>\n",
      image: "machine_building_enterprises.jpeg",
      count: [
        {
          start: 1,
          end: 300,
          step: 3,
          content: {
            ru: 'Успешно выполненных заказов',
            ua: 'Успішно виконаних замовлень',
            en: 'Successfully completed orders'
          },
        },
        {
          start: 1,
          end: 240,
          step: 3,
          content: {
            ru: 'МВт отремонтированных электродвигателей',
            ua: 'Вт відремонтованих електродвигунів',
            en: 'MW of repaired electric motors '
          },
        },
        {
          start: 1,
          end: 135,
          step: 1,
          content: {
            ru: 'Тонн изготовленных секций',
            ua: 'Тонн виготовлених секцій',
            en: 'Tons of manufactured sections'
          },
        },
      ],
    },
  },
];


export const ButtonLocales =  {
  ru: "Узнать про наши услуги",
  en: "Find out about our services",
  ua: "Дізнатися про наші послуги",
}

export const ButtonDividerLocales =  {
  ru: "Свяжитесь с нами",
  en: "Contact us",
  ua: "Зв'яжіться з нами",
}

export const DividerLocales =  {
  ru: {
    content_1: "Остались вопросы?",
    content_2: "Мы готовы на них ответить!",
  },
  en: {
    content_1: "Still have questions?",
    content_2: "We are ready to answer them!",
  },
  ua: {
    content_1: "Залишилися питання?",
    content_2: "Ми готові на них відповісти!",
  },
}

